import { useContext } from "react";
import { UserContext } from "./components/TokenAuthenticator";
import Login from "./components/Login";
import { useNavigate } from "react-router-dom";
import Header from "./components/Header";

const Home = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gray-100 py-12 md:py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 md:mb-8">The missing backend for tldraw</h2>

          {!user ? (
            <Login />
          ) : (
            <button className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600" onClick={goToDashboard}>
              Go to my dashboard
            </button>
          )}

        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded shadow">
              <i className="bi bi-cloud-check text-4xl text-blue-500 mb-4"></i>
              <h3 className="text-xl font-semibold mb-4">Secure and Accessible</h3>
              <p>Save all your drawings to a secure and reliable backend. Find them anywhere on any device.</p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <i className="bi bi-share text-4xl text-green-500 mb-4"></i>
              <h3 className="text-xl font-semibold mb-4">Powerful Sharing</h3>
              <p>Share specific drawings with the world. Use powerful sync features to showcase live schemas to your users.</p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <i className="bi bi-clock-history text-4xl text-purple-500 mb-4"></i>
              <h3 className="text-xl font-semibold mb-4">Version Control</h3>
              <p>Never miss an edit. Go back in time and find what you had drawn days before.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-4 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p>&copy; 2023 Draw. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
